import api from '@/apis/tax/tARiskCustomerVendorAPI.js';
import Crud from '@/stores/crudBase.js';

var crud = new Crud('taRiskCustomerVendor', api);

const state = {
  ...crud.state,
  _config: {
    table: 'ta_risk_customer_vendor',
    field: {
      key: 'ta_risk_customer_vendor_id',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
